module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0124.jpg?v=9fca33a7";